import { AccountType } from "../types/AccountType";

// HEYHEY: We used to have 2 maps, one that rendered the related guided-flow child components and another that kept track of the total number of steps for each guided-flow entity type
// Essentially consolidating them into 1 map since we can use the related accountType.length to grab the step number
// In the future, if we ever need to add more steps to our guided-flow, create a new variable and set the related entity type's value to that variable, similar to how we have it set up right now

const guidedFlowComponentsArray = ["account-owner", "account-details"];

export const GUIDED_FLOW_COMPONENT_STEPS = {
  // This tells the guided-flow component which components to render for each step
  // i.e. investment renders account-owner for step 1 and account-details for step 2
  [AccountType.BANK]: guidedFlowComponentsArray,
  [AccountType.RETIREMENT_ANNUITY]: guidedFlowComponentsArray,
  [AccountType.INVESTMENT]: guidedFlowComponentsArray,
  [AccountType.REAL_ESTATE]: guidedFlowComponentsArray,
  [AccountType.MORTGAGE]: guidedFlowComponentsArray,
  [AccountType.LIABILITIES]: guidedFlowComponentsArray,
  [AccountType.TRUST]: guidedFlowComponentsArray,
}
